import { createFileRoute } from "@tanstack/react-router"
import { WaitlistWelcomePage } from "@/pages"

export const Route = createFileRoute(
  "/_authenticated/_account/waitlist-welcome"
)({
  component: WaitlistWelcomePage,
})
